import { render, staticRenderFns } from "./buytest.vue?vue&type=template&id=430ff0ba&scoped=true&"
import script from "./buytest.vue?vue&type=script&lang=js&"
export * from "./buytest.vue?vue&type=script&lang=js&"
import style0 from "./buytest.vue?vue&type=style&index=0&id=430ff0ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "430ff0ba",
  null
  
)

export default component.exports